<script>
	import { onMount } from 'svelte'
	import gsap from 'gsap'
	import { ScrollTrigger } from 'gsap/ScrollTrigger'
	gsap.registerPlugin(ScrollTrigger)

	export let accordion
	// console.log('accordion:', accordion)

	let windowLocation = window.location.href

	function openItem(e) {
		let currentIsActive = e.target
			.closest('.accordion-block-item')
			.classList.contains('active')
		let elems = document.querySelectorAll('.accordion-block-item.active')
		let testimonialContent = e.target
			.closest('.accordion-block-item')
			.getElementsByClassName('accordion-block-item-content')[0]
		let contentHeight = undefined
		if (testimonialContent) {
			contentHeight = testimonialContent.clientHeight
		}

		;[].forEach.call(elems, function(e) {
			let svgWrap = e.querySelector('.cond-inner-learn-more-svg-wrap')
			//remove active class from all elements
			e.classList.remove('active')
			//reset padding
			e.style.paddingBottom = 0
			//reset svg
			e.querySelector('.cond-inner-learn-more-svg-wrap').classList.remove(
				'svg-transition'
			)
		})

		if (currentIsActive == false) {
			//add active class to element targeted
			//the active class will be removed from an element that is already active
			e.target.closest('.accordion-block-item').classList.add('active')
			//add padding equivalent to content height
			e.target.closest('.accordion-block-item').style.paddingBottom =
				contentHeight + 'px'
			e.target
				.closest('.accordion-block-item')
				.querySelector('.cond-inner-learn-more-svg-wrap')
				.classList.add('svg-transition')
		}
	}

	onMount(() => {
		let acc_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.accordion-block',
				start: 'top-=350 center', // when the top of the trigger hits the center of the viewport (+49 pixels)
				// markers: true,
				// toggleActions: 'play pause resume reset',
			},
		})
		let items = document.querySelectorAll('.accordion-block-item')
		items.forEach(el => {
			acc_tl.fromTo(
				el,
				{
					opacity: 0,
					y: -20,
				},
				{
					duration: 0.3,
					delay: 0,
					opacity: 1,
					y: 0,
				}
			)
		})

		windowLocation = window.location.href
		if (windowLocation.indexOf('#') >= 0) {
			let elementToOpen = windowLocation.substring(
				windowLocation.indexOf('#') + 1
			)
			setTimeout(() => {
				document.getElementById(elementToOpen).click()
			}, 1000)
		}
	})
</script>

{#each accordion as item, i}
	{#if !item.anchor_toggle}
		<div class="accordion-block-item" on:click={openItem}>
			<div class="cond-inner">
				<div class="cond-inner-outer-wrap">
					<div class="cod-inner-wrap">
						<h3>
							{@html item.title}
						</h3>
						<div class="cond-inner-learn-more">
							<div class="cond-inner-learn-more-svg-wrap">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									x="0"
									y="0"
									viewBox="0 0 16.5 16.5"
									xml:space="preserve">
									<style>
										.stplus {
											fill-rule: evenodd;
											clip-rule: evenodd;
											fill: #616161;
										}
									</style>
									<path
										class="stplus stplus-first"
										d="M6.9 16.5h2.7V0H6.9v16.5z" />
									<path class="stplus" d="M0 6.9h16.5v2.7H0z" />
								</svg>
							</div>
						</div>
					</div>
					<div class="accordion-block-item-content">
						{@html item.content}
					</div>
				</div>
			</div>
		</div>
	{:else}
		<div
			class="accordion-block-item cond accordion-block-anchor"
			on:click={openItem}>
			<div
				class="elementSpacer"
				id={item.title.toLowerCase().replaceAll(' ', '_')} />
			<div class="cond-inner">
				<div class="cond-inner-outer-wrap">
					<div class="cod-inner-wrap">
						<h3>
							{@html item.title}
						</h3>
						<div class="cond-inner-learn-more">
							<div class="cond-inner-learn-more-svg-wrap">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									x="0"
									y="0"
									viewBox="0 0 16.5 16.5"
									xml:space="preserve">
									<style>
										.stplus {
											fill-rule: evenodd;
											clip-rule: evenodd;
											fill: #616161;
										}
									</style>
									<path
										class="stplus stplus-first"
										d="M6.9 16.5h2.7V0H6.9v16.5z" />
									<path class="stplus" d="M0 6.9h16.5v2.7H0z" />
								</svg>
							</div>
						</div>
					</div>
					<div class="accordion-block-item-content">
						{@html item.content}
					</div>
				</div>
			</div>
		</div>
	{/if}
{/each}